export default __webpack_public_path__ + "static/media/polgot-screenshot-04.07f948d0.png";